import React, { useState, useEffect } from 'react';
import { Box, FormControl, TextField,Autocomplete } from '@mui/material';
//import { AutocompleteRenderInputParams } from '@mui/material';
import deviceStyles from '../../app/device-management/DeviceStyle';
//import Chip from '@mui/material/Chip';
import Checkbox from '@mui/material/Checkbox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import sortBy from 'lodash/sortBy';
import { ChildDevice, GatewayDevice } from '../../types/device';
import { useDeviceBlueprint } from '../../data/DataProviders/DeviceBlueprintProvider';
import { isDataLoaded, isDataLoading } from '../../types';
import { sortByChildDeviceCount } from '../../lib/device-helpers';

export const DeviceAutoComplete: React.FC<{
    childDeviceList?: ChildDevice[];
    selectedDevices: Function;
    isBlueprintExist: boolean;
    disabled?: boolean;
    orgName?: string;
    blueprintError?: Function;
}> = (props) => {
    const classes = deviceStyles();
    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;
    const sortedchildDeviceList = sortBy(props.childDeviceList, 'type');
    const deviceBlueprintData = useDeviceBlueprint();
    const [childDeviceList, setChildDeviceList] = useState<any[]>([]);
    const [selectedDevice, setSelectedDevice] = useState<GatewayDevice>({
        childDevices: [],
        blueprint: {
            id: '',
            version: '',
        },
        childDeviceTypes: '',
        deviceProfileId: '',
    });

    useEffect(() => {
        setChildDeviceList(sortedchildDeviceList);
    }, [props.childDeviceList]); //eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        props.selectedDevices(selectedDevice);
        if (process.env.NODE_ENV === 'test') {
            const deviceRegistrationData = {
                ...selectedDevice,
                childDevices: [
                    {
                        key: 'atc-900',
                        value: 'Eaton ATC-900',
                        type: 'Automatic Transfer Switches',
                    },
                ],
            };
            props.selectedDevices(deviceRegistrationData);
            if (props.blueprintError) props.blueprintError(false);
        }
    }, [selectedDevice]); //eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (isDataLoaded(deviceBlueprintData.deviceTypeData)) {
            const deviceTypeData = deviceBlueprintData.deviceTypeData.value;
            if (deviceTypeData.length) {
                const bluePrintData = sortByChildDeviceCount(deviceTypeData);
                let uniqueDeviceList = deviceTypeData
                    .map((d: any) => d.deviceID)
                    .join()
                    .split(',');
                uniqueDeviceList = uniqueDeviceList.filter(
                    (value: any, index: any, self: any) => self.indexOf(value) === index
                );
                const childDevices = sortedchildDeviceList;
                const filteredChildDevices = childDevices.filter((d) => uniqueDeviceList.includes(d.key));

                const deviceRegistrationData = {
                    ...selectedDevice,
                    blueprint: {
                        id: bluePrintData.blueprintId || '',
                        version: bluePrintData.blueprintVersion || '',
                    },
                    deviceProfileId: bluePrintData.gatewayProfileId,
                    childDeviceTypes: bluePrintData.childDeviceTypes
                        .map((x: any) => x.key)
                        .sort()
                        .join(','),
                };
                if (props.blueprintError) props.blueprintError(false);
                setSelectedDevice(deviceRegistrationData);
                setChildDeviceList(filteredChildDevices);
            } else {
                if (props.blueprintError) props.blueprintError(true);
                setChildDeviceList(sortedchildDeviceList);
            }
        }
    }, [deviceBlueprintData]); //eslint-disable-line react-hooks/exhaustive-deps

    const deviceChange = (newValue: any[]): void => {
        if (newValue.length) {
            const selectedDeviceTypes = newValue.map((d) => d.key).join();
            deviceBlueprintData.getDeviceBlueprintData(props.orgName, selectedDeviceTypes);
        } else {
            if (props.blueprintError) props.blueprintError(false);
            setChildDeviceList(sortedchildDeviceList);
        }

        const deviceRegistrationData = {
            ...selectedDevice,
            childDevices: newValue,
        };

        setSelectedDevice(deviceRegistrationData);
    };

    const optionDisabled = (): boolean =>
        selectedDevice.childDevices.length > 0 && isDataLoading(deviceBlueprintData.deviceTypeData);

    return <>
        <Box data-testid="device-autoComplete" display="flex" flexDirection="row" alignItems="center" width="100%">
            <FormControl className={classes.addUserformControl} variant="standard" style={{ width: '100%' }}>
                <Autocomplete
                    data-testid="device-autosuggest"
                    multiple
                    limitTags={4}
                    value={selectedDevice.childDevices}
                    id="multiple-device"
                    placeholder="autosuggest"
                    disableCloseOnSelect
                    options={childDeviceList}
                    getOptionLabel={(option: { key: string; value: string; type: string }): string => option.value}
                    isOptionEqualToValue={(option, value): boolean => option.key === value.key}
                    getOptionDisabled={(): boolean => optionDisabled()}
                    onChange={(event, newvalue): void => {
                        deviceChange(newvalue);
                    }}
                    groupBy={(option): string => String(option.type)}
                    // renderTags={(value: any, getTagProps): React.ReactNode =>
                    //     value.map((option: any, index: number) => (
                    //         <Chip
                    //             variant="outlined"
                    //             label={option.value}
                    //             {...getTagProps({ index })}
                    //         />
                    //     ))
                    // }
                    renderOption={(prop,option: any, { selected }): JSX.Element => (
                        <li {...prop}>
                            <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8 }}
                                checked={selected}
                                data-testid="device-checkbox"
                            />
                            {option.value}
                        </li>
                    )}
                    renderInput={(params): React.ReactNode => (
                        <TextField
                            {...params}
                            variant="filled"
                            required
                            label="Supported Device Types"
                            placeholder="Devices"
                            error={props.isBlueprintExist}
                            helperText={
                                props.isBlueprintExist
                                    ? 'Blueprint does not exist for selected device. Please correct and submit again.'
                                    : ''
                            }
                        />
                    )}
                    disabled={props.disabled}
                />
            </FormControl>
        </Box>
    </>;
};
